export default {
  data () {
    return {
      columns: [],
      defaultColumns: null
    }
  },
  computed: {
    columnsList () {
      let columns = []
      for (let [key, value] of Object.entries(this.columnsShow)) {
        columns.push({
          ...value,
          key
        })
      }
      return columns
    }
  },
  methods: {
    showColumn (c) {
      return this.columns.includes(c)
    },
    showOnMobile (c) {
      let entry = this.columnsShow[c]
      if (entry && entry.mobile) {
        return entry.mobile === true
      }
    },
    saveConf () {
      localStorage.setItem(this.columnsConfResource + '_columnsConf', JSON.stringify(this.columns))
    },
    updateColumns (columns) {
      console.log(columns)
      this.columns = columns.slice()
      this.saveConf()
    },
    getConf () {
      const localConf = localStorage.getItem(this.columnsConfResource + '_columnsConf')
      if (localConf) {
        return JSON.parse(localConf)
      }
      return null
    }
  },
  created () {
    if (typeof this.columnsShow !== 'object') {
      console.warn('ColumnConf: You have to define a columnsShow data.')
    } else {
      if (!this.columnsConfResource) {
        return console.warn('ColumnConf: You have to define a columnsConfResource data.')
      }
      const conf = this.getConf()
      if (conf) {
        conf.forEach(c => {
          this.columns.push(c)
        })
      } else {
        for (const k in this.columnsShow) {
          if (!this.defaultColumns || (this.defaultColumns && this.defaultColumns.includes(k))) {
            this.columns.push(k)
          }
        }
        this.saveConf()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ColumnConfMixin.js